var sizeSelector = null;
var materialSelector = null;
var currentProduct = null;

function getSelectors() {
    var singleOptionSelectors = document.getElementsByClassName('single-option-selector');
    for (var i = 0, len = singleOptionSelectors.length | 0; i < len; i = i + 1 | 0) {
        if (singleOptionSelectors[i].id);
        var singleOptionSelectorLabel = document.querySelectorAll('[for="' + singleOptionSelectors[i].id + '"]');
        if (typeof singleOptionSelectorLabel[0] !== 'undefined') {
            if (singleOptionSelectorLabel[0].innerText == 'Size') {
                sizeSelector = singleOptionSelectors[i];
            }
            if (singleOptionSelectorLabel[0].innerText == 'Material ID') {
                materialSelector = singleOptionSelectors[i];
            }
        }
    }
    if (sizeSelector !== null && materialSelector !== null) {
        sizeSelector.addEventListener('change', (event) => {
            variants = currentProduct.variants;
            let possibles = [];
            variants.forEach((variant) => {
                if (variant.options.includes(sizeSelector.value)) {
                    possibles.push(variant.options);
                }
            });

            var materialSelected = false;
            for (let option of materialSelector.options) {
                const value = option.value;
                let flag = false;
                possibles.forEach((possible) => {
                    if (possible.includes(value)) {
                        flag = true;
                    }
                })
                if (flag === false) {
                    option.removeAttribute('selected');
                    option.setAttribute('disabled', 'disabled');
                } else {
                    option.removeAttribute('disabled');
                    if (!materialSelected) {
                        option.selected = true;
                        materialSelected = true;
                        var event = new Event('change');
                        materialSelector.dispatchEvent(event);
                    }
                }
            }
        });
        materialSelector.parentNode.style.display = 'none';
    }
}

function updatePaintMaterial(product, selector) {
    if (sizeSelector == null && materialSelector == null) {
        getSelectors();
    }
    currentProduct = product;
}